import { useCallback, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, useNavigate } from "react-router-dom";

import { useTheme } from "@mui/material/styles";

import { useDialogs, useSnackbar } from "@/context";
import { ActionState, ActionType } from "@/types";


export const useServices = () => {
  const theme = useTheme();
  const { user, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  const { openDialog, closeDialog } = useDialogs();
  const { openSnackbar } = useSnackbar();

  return {
    auth: { getAccessTokenSilently, user },
    nav: { navigate, location },
    ui: { openSnackbar, openDialog, closeDialog, theme }
  }
}

export const useActionWorkflow = () => {

  const [action, setAction] = useState<ActionState>({
    status: 'idle',
    type: null,
    error: null,
    message: ''
  });

  const updateMessage = useCallback((message: string) => {
    setAction(prev => ({ ...prev, message }));
  }, []);

  const runAction = useCallback(async (type: ActionType, message: string, task: (taskMessage: (message: string) => void) => Promise<any>) => {
    setAction({ status: 'loading', type, error: null, message });
    try {
      await task(updateMessage);
      setAction({ status: 'success', type, error: null, message: '' });
    } catch (err: any) {
      setAction({ status: 'error', type, error: err.message || null, message: '' })
    }
  }, [updateMessage]);

  const resetAction = useCallback(() => {
    setAction({ status: 'idle', type: null, error: null, message: '' });
  }, []);



  return { action, runAction, resetAction, updateMessage }

}
